module.exports = __webpack_public_path__ + "static/lux-d-camera-db86f81181374d0c45e6ee013272601a.png";